import { merge } from 'lodash-es';

export const mergeStrict = <T>(...source: ReadonlyArray<T>): T => {
  return merge({} as T, ...source);
};
